import { useTranslation } from "react-i18next";

import { COMPLETE_CHANNELS_REGEXP, RENEW_CHANNEL } from "config/channels";
import { Offer } from "models/Offers";
import { PRODUCTS_NAME } from "types/products";

export const checkForOfferToRenew = ({ channel, renewOffer }: { channel?: string; renewOffer?: Offer }) => {
  if (channel !== RENEW_CHANNEL) {
    return;
  }
  return renewOffer;
};

export const getEssentialProduct = (offers: Record<string, Offer>) => {
  const name = PRODUCTS_NAME.AIR_BUNDLE_MEMBERSHIP_ESSENTIAL_ANNUALLY;

  return offers[name];
};

export const getCompleteProduct = (offers: Record<string, Offer>, summerTimeEnabled?: boolean) => {
  const name = summerTimeEnabled
    ? PRODUCTS_NAME.MEMBERSHIP_COMPLETE_ANNUALLY
    : PRODUCTS_NAME.AIR_BUNDLE_MEMBERSHIP_COMPLETE_ANNUALLY;

  return offers[name];
};

export const getMembershipPlanByChannel = ({
  channel,
  renewOffer,
  offers,
  summerTimeEnabled,
}: {
  channel?: string;
  renewOffer?: Offer;
  offers: Record<string, Offer>;
  summerTimeEnabled?: boolean;
}) => {
  const offerToRenew = checkForOfferToRenew({ channel, renewOffer });
  if (offerToRenew) {
    return offerToRenew;
  }

  const isCompleteChannel = !!channel && COMPLETE_CHANNELS_REGEXP.test(channel);
  return isCompleteChannel ? getCompleteProduct(offers, summerTimeEnabled) : getEssentialProduct(offers);
};

export const isCompleteAnnualMembership = (productName: PRODUCTS_NAME) => {
  return productName.includes("membership_complete");
};

export const isEssentialAnnualMembership = (productName: PRODUCTS_NAME) => {
  return productName.includes("membership_essential");
};

export const getProductTitle = ({ productName, channel }: { productName: PRODUCTS_NAME; channel?: string }) => {
  const { t } = useTranslation();
  const plan = isCompleteAnnualMembership(productName) ? t("pricing.plans.complete") : t("pricing.plans.essential");

  if (channel === RENEW_CHANNEL) {
    return `${t("common.renew")} ${t("common.airhelp_plus_plan_membership", { plan })}`;
  }
  return t("common.airhelp_plus_plan_membership", { plan });
};

export const checkPromoCodeEntitlement = (channel?: string, claimId?: string) => {
  return channel !== RENEW_CHANNEL && !claimId;
};

export const getActionNameForProduct = (productName?: PRODUCTS_NAME) => {
  const { t } = useTranslation();
  if (!productName) {
    return t("payment.pay");
  }
  if (isCompleteAnnualMembership(productName)) {
    return t("payment.checkout.start_title", { plan: t("pricing.plans.complete") });
  }
  if (isEssentialAnnualMembership(productName)) {
    return t("payment.checkout.start_title", { plan: t("pricing.plans.essential") });
  }

  if (productName == PRODUCTS_NAME.UPGRADE_TO_TRIP_COMPLETE) {
    return t("payment.checkout.upgrade_title", { plan: t("pricing.plans.complete") });
  }
  return t("payment.pay");
};
